var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRetentionShare = function SvgRetentionShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 1.5a9.5 9.5 0 1 1 0 19 9.5 9.5 0 0 1 0-19zm0 1.217a8.283 8.283 0 1 0 .057 16.566V2.717zm8.276 8.622-7.002-.001v7.848a8.286 8.286 0 0 0 7.002-7.847zm-7.002-8.525v7.307h6.963a8.288 8.288 0 0 0-6.963-7.307z",
    fill: "#000",
    fillRule: "nonzero"
  }))));
};

export default SvgRetentionShare;